import React, { useMemo } from "react";
import { Grid, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import ReportSummary from "../ReportSummary";
import Number from "../../../../custom/Number";
import moment from "moment-business-days";

const ContractSummary = ({ summary, disabled, currentUser }) => {
  const items = useMemo(() => {
    if (!summary) return [];

    return [
      {
        label: "app.report.summary.contract.contractCount",
        value: summary?.contractCount,
        gridProps: { xs: 12, sm: 6, md: 4 },
      },
      {
        label: "app.report.summary.contract.custodiedAmount",
        gridProps: { xs: 12, sm: 6, md: 4 },
        value: (
          <Number
            value={!disabled ? summary?.custodiedAmount : null}
            currency="LCT"
            taxResidence={currentUser?.taxResidence}
            canCopySufix={false}
          />
        ),
      },
      {
        label: "app.report.summary.contract.totalYield",
        gridProps: { xs: 12, sm: 6, md: 4 },
        value: (
          <Number
            value={!disabled ? summary?.totalYield : null}
            currency="LCT"
            taxResidence={currentUser?.taxResidence}
            canCopySufix={false}
          />
        ),
      },
      {
        label: "app.report.summary.contract.firstOpenDate",
        gridProps: { xs: 12, sm: 6, md: 6 },
        value: summary?.firstOpenDate ? moment(summary.firstOpenDate).format("DD/MM/YYYY") : "...",
      },
      {
        label: "app.report.summary.contract.lastDueDate",
        value: summary?.lastDueDate ? moment(summary.lastDueDate).format("DD/MM/YYYY") : "...",
        gridProps: { xs: 12, sm: 6, md: 6 },
      },
    ];
  }, [summary, disabled, currentUser]);

  if (!summary) return null;

  return (
    <ReportSummary
      disabled={disabled}
      timeout={200}
    >
      <Grid
        container
        spacing={3}
      >
        {items.map((item) => (
          <Grid
            item
            {...item.gridProps}
            key={item.label}
          >
            <Typography
              variant="body1"
              color="primary"
              align="center"
            >
              <FormattedMessage id={item.label} />
            </Typography>

            <Typography
              variant="body2"
              align="center"
            >
              {disabled ? "..." : item.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </ReportSummary>
  );
};

export default ContractSummary;
